import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import React, { useState } from "react";
import { WalletNotConnectedError } from "@solana/wallet-adapter-base";
import {
  Connection,
  GetProgramAccountsFilter,
  Keypair,
  LAMPORTS_PER_SOL,
  PublicKey,
  SystemProgram,
  Transaction,
} from "@solana/web3.js";
import {
  createAssociatedTokenAccountInstruction,
  createTransferInstruction,
  getAssociatedTokenAddress,
  getOrCreateAssociatedTokenAccount,
  TokenAccountNotFoundError,
  TOKEN_PROGRAM_ID,
} from '@solana/spl-token';

function TransactionForm(props) {
  const [recieverAddress, setRecieverAddress] = useState("");
  const [amount, setAmount] = useState(0);
  const { connection } = useConnection();
  const { publicKey, sendTransaction } = useWallet();


  const sendAndConfirmTransaction = async (transaction, connection) => {
    const signature = await sendTransaction(transaction, connection);
    console.log('Transaction sent:', signature);
    const latestBlockHash = await connection.getLatestBlockhash();
    const confirmation = await connection.confirmTransaction({
      blockhash: latestBlockHash.blockhash,
      lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
      signature: signature,
    });
    if (confirmation) {
      alert(`Transaction confirmed for ID ${signature}!`);
    }
  };

  async function transact() {
    if (!publicKey) throw new WalletNotConnectedError();

    // const lamports = await connection.getMinimumBalanceForRentExemption(0);
    // const randomRecieverKey = Keypair.generate().publicKey;

    try {
      if (props.selectedToken.mintAddress === "SOL") {
        const solsToSend = LAMPORTS_PER_SOL * amount;
        const transaction = new Transaction().add(
          SystemProgram.transfer({
            fromPubkey: publicKey,
            toPubkey: recieverAddress,
            lamports: solsToSend,
          })
        );

        const {
          context: { slot: minContextSlot },
          value: { blockhash, lastValidBlockHeight },
        } = await connection.getLatestBlockhashAndContext();

        const signature = await sendTransaction(transaction, connection, {
          minContextSlot,
        });

        await connection.confirmTransaction({
          blockhash,
          lastValidBlockHeight,
          signature,
        });

        console.log("SIGNATURE", signature);
      }
      else {
        let sourceAccount = await getOrCreateAssociatedTokenAccount(
          connection,
          Keypair.generate(),
          new PublicKey(props.selectedToken.mintAddress),
          publicKey
        );
        console.log(`Source Account: ${sourceAccount.address.toString()}`);

        let destinationAccount = await getOrCreateAssociatedTokenAccount(
          connection,
          Keypair.generate(),
          new PublicKey(props.selectedToken.mintAddress),
          new PublicKey(recieverAddress)
        );
        console.log(`Destination Account: ${destinationAccount.address.toString()}`);
        //send transaction directly now
        const transaction = new Transaction();
        transaction.add(
          createTransferInstruction(
            sourceAccount.address,
            destinationAccount.address,
            publicKey,
            parseFloat(amount) * Math.pow(10, props.selectedToken.decimals)
          )
        );
        await sendAndConfirmTransaction(transaction, connection);
      }
      alert("Successfully sent the tokens");
      setAmount(0);
      setRecieverAddress("");
    }
    catch (error) {
      if (error instanceof TokenAccountNotFoundError) {
        alert("Token account not found");
      }
      else {
        alert(error);
      }
    }
  }

  let isEnabledBtn = props.selectedToken && props.selectedToken !== "" && publicKey && recieverAddress !== "" && amount !== "";

  return (
    <>
      <div>
      <div>Step 3: Enter reciever address</div>
        <input
          style={{ padding: "20px", width: "100%", margin: "10px 0",marginBottom:"5vh", display: "block", fontSize: "1.2em" }}
          type="text" value={recieverAddress} onChange={e => { setRecieverAddress(e.target.value) }} />
        <div>Step 4: Select token amount</div>
         <input
          style={{ padding: "20px", width: "100%", margin: "10px 0",marginBottom:"5vh", display: "block", fontSize: "1.2em" }} type="number" value={amount} onChange={e => { setAmount(e.target.value) }} />
        <div>Step 5: Send the tokens and check transaction details</div>
        <button
          style={{ padding: "20px", width: "100%", margin: "10px 0",marginBottom:"5vh", display: "block", fontSize: "1.2em" }}
          onClick={transact} disabled={!isEnabledBtn}>Send</button>
      </div>
    </>
  )
}

export default TransactionForm;